/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import Loader from "../Common/Loader";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ActivateCard from "./ActivateCard";
import DeActivateCard from "./DeActivateCard";
import UpdateCardNumber from "./UpdateCardNumber";
import CardContext from "../../Context/CardContext";
import Pagination from "../Common/Pagination";
import StudentCardSearchForm from "../Common/StudentCard/StudentCardSearchForm";
import MarkCardAsLost from "./MarkCardAsLost";
import EmergencyCardUpdate from "./EmergencyCardUpdate";
import { RenderSecure } from "../../util/script/RenderSecure";

function AssignedCards(props) {
    const [modal, setModal] = useStateCallback(false);
    const {assignedPage, page, inactivePage, unassignedPage, assignedMeta, setAssignedPage, assignedFirst, assignedQuery, setAssignedQuery, loading, loading2, assignedCardList, getAssignedCards, getCards, getInactiveCards, getUnassignedCards, searchAssignedCard, countAssignedCards,
      countAssignedWristbands} = useContext(CardContext);

    const handlePagination = (newPage) => {
      if (newPage > 0 && newPage <= assignedMeta) {
        setAssignedPage(newPage);
      }
    };

    const setCards = (e) => {
      e.preventDefault();
      setAssignedQuery("");
      setAssignedPage(1);
      getAssignedCards(1);
    };
  
    useEffect(() => {
      if (assignedQuery) {
        searchAssignedCard();
      } else {
        getAssignedCards(assignedPage);
      }
    }, [assignedPage]);


  const lostCard=(e,item)=>{
    setModal(false, ()=>setModal(<MarkCardAsLost cardID={item.card_id} getAllCards={getCards} getAssignedCards={getAssignedCards} getInactiveCards={getInactiveCards} 
          getUnassignedCards={getUnassignedCards} page={page} assignedPage={assignedPage} inactivePage={inactivePage} unassignedPage={unassignedPage} countAssignedCards={countAssignedCards} 
          countAssignedWristbands={countAssignedWristbands} isOpen={true}/>))
  }

  const cardOn=(e,item)=>{
    setModal(false, ()=>setModal(<ActivateCard cardID={item.card_id} page={page} inactivePage={inactivePage} getAllCards={getCards} getInactiveCards={getInactiveCards} isOpen={true}/>))
  }

  const cardOff=(e,item)=>{
    setModal(false, ()=>setModal(<DeActivateCard cardID={item.card_id} page={page} inactivePage={inactivePage} getAllCards={getCards} getInactiveCards={getInactiveCards} isOpen={true}/>))
  }
  
  const updateCard=(e,item)=>{
    setModal(false, ()=>setModal(<UpdateCardNumber cardID={item.card_id} cardNumber={item.card_number} cardType={item.type} getAllCards={getCards} page={page} isOpen={true}/>))
  }

  const emergencyCardUpdate=(e,item)=>{
    setModal(false, ()=>setModal(<EmergencyCardUpdate studentID={item.student.student_id} getAllCards={getAssignedCards} page={assignedPage} isOpen={true}/>))
  }

    return (
        <>
      {modal}
      
        <StudentCardSearchForm searchTerm={assignedQuery} setSearchTerm={setAssignedQuery} searchCards={searchAssignedCard} setCards={setCards} setPage={setAssignedPage} placeholder="Enter card / wristband number or student name..."/>
        <div className="table-responsive">
          {loading || loading2 ? (
            <Loader /> 
          ) : (
            <table className="table display data-table text-nowrap">
            <thead>
            <tr>
            <th scope="col" className="wd-10p">No.</th>
            <th>Serial Number</th>
            <th>Type</th>
            <th>Student Name</th>
            <th>Status</th>
            <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {assignedCardList.length > 0 ? (
            assignedCardList.map((item, index) => (
              <tr key={index}>
                <th scope='row' style={{width:"5px"}}>{index + assignedFirst + 1}</th>
                <td>{item.card_number}</td>
                <td>{item.type==="CARD"?<span class="badge badge-info">{item.type}</span>:<span class="badge badge-wb">{item.type}</span>}</td>
                <td><Link to={`/students/profile/${item.student.student_id}/${item.student.user_id}`}>
                                                    {item.student.full_name}
                                                    </Link></td>
                      <td>{item.status==="1"?<span class="badge badge-success">Assigned</span>
                      :<span class="badge badge-danger">De-activated</span>}</td>
                      <td>
                        <div className="dropdown">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false">
                            <span className="flaticon-more-button-of-three-dots"></span>
                          </Link>
                          <div className="dropdown-menu dropdown-menu-right">
                          
                          <Link
                            className="dropdown-item"
                            to="#"
                            onClick={(e) => updateCard(e,item)}>
                            <i className="fa fa-edit mr-1"></i>
                            Change Serial Number
                          </Link>
                            <Link
                            className="dropdown-item"
                            to="#"
                            onClick={(e) => lostCard(e,item)}>
                            <i className="fa fa-link-slash mr-1" style={{color:"red"}}></i>
                            Mark as Lost
                          </Link>
                          {item.status==="1"?<Link
                            className="dropdown-item"
                            to="#"
                            onClick={(e) => cardOff(e,item)}>
                            <i className="fa fa-ban mr-1" style={{color:"red"}}></i>
                            De-Activate / Block
                          </Link>:<Link
                            className="dropdown-item"
                            to="#"
                            onClick={(e) => cardOn(e,item)}>
                            <i className="fa fa-power-off mr-1" style={{color:"green"}}></i>
                            Re-Activate / Unblock
                          </Link>}
                         <RenderSecure code="ADMIN-VIEW"><Link
                        className="dropdown-item"
                        to="#"
                        onClick={(e) => emergencyCardUpdate(e,item)}>
                        <i className="fa fa-triangle-exclamation mr-1"></i>
                        Emergency Update
                      </Link></RenderSecure></div>
                        </div>
                      </td>
              </tr>
            ))
            ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No cards / wristbands registered yet.
              </td>
            </tr>
            )}
            </tbody>
            </table>
          )}
        </div>
        <Pagination currentPage={assignedPage} totalPages={assignedMeta} onPageChange={handlePagination}/>

         </>
  );
}

export default AssignedCards;
